import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ToastService } from "./toasts.service";
import { Folder, FolderPlanogram, PlanogramSearchResult } from "../models/folder";
import * as requests from '../requests/index';
import { BaseApiService } from "./base-api.service";

@Injectable({
    providedIn: 'root'
})
export class FolderApiService extends BaseApiService {
    constructor(http: HttpClient, toastService: ToastService) {
        super(http, toastService);
    }

    /**
     * Fetches all root folders accessible by the current user.
     * @returns An Observable of an array of Folder objects.
     */
    getUserRootFolders(includePlanograms: boolean = true): Observable<Folder[]> {
        //If includePlanograms = false then it doesn't also query planograms associated with the folders, for when you only want the accessible folder structure of a user.
        return this.apiRequest<Folder[]>(
            `folders/get-user-folders?includePlanograms=${includePlanograms}`,
            'GET',
            null,
            'Failed to load user folders'
        );
    }

    getFolderContents(folderId: string): Observable<Folder> {
        return this.apiRequest<Folder>(
            `folders/get-folder-contents/${folderId}`,
            'GET',
            null,
            'Failed to load folder contents'
        );
    }

    getUserSharedPlanograms() : Observable<FolderPlanogram[]> {
        return this.apiRequest<FolderPlanogram[]>(
            `folders/get-user-shared-planograms`,
            'GET',
            null,
            'Failed to load planograms'
        );
    }

    getNotificationPlanogram(notificationId: string) : Observable<FolderPlanogram> {
        return this.apiRequest<FolderPlanogram>(
            `folders/get-notification-planogram/${notificationId}`,
            'GET',
            null,
            'Failed to load planogram linked to notification'
        );
    }

    getSharedPlanogram(planogramId: string) : Observable<FolderPlanogram> {
        return this.apiRequest<FolderPlanogram>(
            `folders/get-shared-planogram/${planogramId}`,
            'GET',
            null,
            'Failed to load planogram linked to notification'
        );
    }

    deleteFolder(folderId: string): Observable<void>
    {
        return this.apiRequest<void>(
            `folders/delete-folder`,
            'POST',
            { folderId },
            'Failed to delete folder'
        );
    }

    createFolder(parentFolderId: string, folderName: string): Observable<Folder>{
        return this.apiRequest<Folder>(
            `folders/create-folder`,
            'POST',
            new requests.CreateFolderRequest(parentFolderId, folderName),
            'Failed to create folder'
        );
    }

    movePlanograms(parentFolderId: string, planograms: string[]){
        return this.apiRequest<Folder>(
            `folders/move-planograms`,
            'POST',
            new requests.MovePlanogramsRequest(parentFolderId, planograms),
            'Failed to move planograms to destination folder'
        );
    }

    searchPlanogramsGlobal(term: string): Observable<PlanogramSearchResult[]> {
        return this.apiRequest<PlanogramSearchResult[]>(
            `folders/search-planograms?term=${encodeURIComponent(term)}`,
            'GET',
            null,
            'Failed to search planograms'
        );
    }
}
